<template>
  <v-data-table
    :headers="headers"
    :items="batches"
    :sort-by="['startedAt']"
    :sort-desc="[true]"
    @click:row="selectBatch"
    class="elevation-1 clickable-rows"
  >
    <template v-slot:item.startedAt="{ item }">
      {{ formatDateTime(item.startedAt) }}
    </template>

    <template v-slot:item.completedAt="{ item }">
      {{ item.completedAt ? formatDateTime(item.completedAt) : '-' }}
    </template>

    <template v-slot:item.durationSeconds="{ item }">
      {{ formatDuration(item.durationSeconds) }}
    </template>

    <template v-slot:item.currentStatus="{ item }">
      <v-chip :color="getStatusColor(item)" small>
        {{ item.currentStatus }}
      </v-chip>
    </template>

    <template v-slot:item.success="{ item }">
      <v-icon :color="item.success ? 'success' : 'error'">
        {{ item.success ? 'mdi-check-circle' : 'mdi-alert-circle' }}
      </v-icon>
    </template>

    <template v-slot:item.totalEventsCount="{ item }">
      {{ item.totalEventsCount.toLocaleString() }}
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";

export default {
    name: "ProvisionBatchTable",
    props: {
        batches: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            headers: [
                { text: "Batch ID", value: "batchId", sortable: false },
                { text: "Started", value: "startedAt" },
                { text: "Completed", value: "completedAt" },
                { text: "Duration", value: "durationSeconds" },
                { text: "Status", value: "currentStatus" },
                { text: "Success", value: "success", align: "center" },
                { text: "Events", value: "totalEventsCount", align: "right" },
                { text: "Purchase Inv.", value: "purchaseInvoicesCount", align: "right" },
                { text: "Sales Inv.", value: "salesInvoicesCount", align: "right" }
            ]
        };
    },
    methods: {
        selectBatch(batch) {
            this.$emit("select-batch", batch.batchId);
        },
        formatDateTime(dateString) {
            return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
        },
        formatDuration(seconds) {
            if (!seconds) return "-";
            const minutes = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${minutes}m ${secs}s`;
        },
        getStatusColor(item) {
            if (item.success) return "success";
            if (item.currentStatus === "Failed") return "error";
            if (item.currentStatus === "Completed") return "success";
            return "info";
        }
    }
};
</script>

<style scoped>
.clickable-rows >>> tbody tr {
  cursor: pointer;
}
.clickable-rows >>> tbody tr:hover {
  background-color: #f5f5f5;
}
</style>
